import sdk from '@xiaoduo/plugin_sdk'
import mainShare from './mainShare'

export const isDev = process.env.NODE_ENV === 'development'

export default function initPlugin() {
  console.log('【plugin】init start ')
  sdk.updateConfig({
    projectKey: 'xiaoduo-simulation-training',
    refreshInterval: 120 * 60 * 1000, // 120分钟刷新一次
    // isDev, // 开发模式下使用本地插件列表
    devBind: {
      '*': [
        {
          name: 'audioVoicesToken',
          identifier: 'audioVoicesToken_1750058702540',
        },
        {
          name: 'Dashboard_Banner',
          identifier: 'Dashboard_Banner_1751436291509',
        },
        {
          name: 'voiceH5WhiteList',
          identifier: 'voiceH5WhiteList_1753067591620',
        },
        {
          name: 'responseEndLimit',
          identifier: 'responseEndLimit_1759111301198',
        },
      ],
      'tenant_id=q-63563e97292f2a3ecb596b74': [
        {
          identifier: 'duoce_inlay_dialog_detail_tab_1729862909607',
          name: 'duoce_inlay_dialog_detail_tab',
          extraParams: '88ef7d93-3d5d-406d-bcfc-2f6d05d3091b',
        },
      ],
    },
  })

  // 注册共享给插件的依赖
  sdk.registerDependencyShare('@main', () => import('./mainShare'))
  sdk.registerDependencyShare('@xiaoduo/plugin_sdk', () => import('@xiaoduo/plugin_sdk'))
  sdk.registerDependencyShare('react', () => import('react'))
  sdk.registerDependencyShare('antd5', () => import('antd5'))
  sdk.registerDependencyShare('ahooks', () => import('ahooks'))

  // 注册共享给插件的能力
  sdk.registerMainShare(mainShare)

  console.log('【plugin】inited')
}
